import registerWithErrorBoundary from '@utils/registerWithErrorBoundary';

import SubscribeTest from '@components/pages/SubscribeTest/index';

registerWithErrorBoundary({
  SubscribeTest,
});
